var ConsumerAddressType;
(function (ConsumerAddressType) {
    ConsumerAddressType["SHIPPING_ADDRESS"] = "SHIPPING_ADDRESS";
    ConsumerAddressType["BILLING_ADDRESS"] = "BILLING_ADDRESS";
    ConsumerAddressType["CONSUMER_ACCOUNT_CONTACT_ADDRESS"] = "CONSUMER_ACCOUNT_CONTACT_ADDRESS";
    ConsumerAddressType["MERCHANT_ADDRESS"] = "MERCHANT_ADDRESS";
    ConsumerAddressType["STORE_ADDRESS"] = "STORE_ADDRESS";
    ConsumerAddressType["CONSUMER_ACCOUNT_SHIPPING_ADDRESS"] = "CONSUMER_ACCOUNT_SHIPPING_ADDRESS";
})(ConsumerAddressType || (ConsumerAddressType = {}));
var IdentityCheckStatus;
(function (IdentityCheckStatus) {
    IdentityCheckStatus["NOT_REQUIRED"] = "NOT_REQUIRED";
    IdentityCheckStatus["NOT_VERIFIED"] = "NOT_VERIFIED";
    IdentityCheckStatus["VERIFIED"] = "VERIFIED";
    IdentityCheckStatus["FAILED"] = "FAILED";
    IdentityCheckStatus["PARTIAL_VERIFIED"] = "PARTIAL_VERIFIED";
})(IdentityCheckStatus || (IdentityCheckStatus = {}));
var PreferredPaymentMethod;
(function (PreferredPaymentMethod) {
    PreferredPaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
    PreferredPaymentMethod["APPLE_PAY"] = "APPLE_PAY";
    PreferredPaymentMethod["ACH_BANK_ACCOUNT"] = "ACH_BANK_ACCOUNT";
    PreferredPaymentMethod["CASH_APP_PAY"] = "CASH_APP_PAY";
})(PreferredPaymentMethod || (PreferredPaymentMethod = {}));
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["NO_VALUE"] = "NO_VALUE";
    AccountStatus["NEW"] = "NEW";
    AccountStatus["REGISTERED"] = "REGISTERED";
    AccountStatus["UNREGISTERED"] = "UNREGISTERED";
    AccountStatus["DISABLED"] = "DISABLED";
    AccountStatus["ON_HOLD"] = "ON_HOLD";
    AccountStatus["SUSPENDED"] = "SUSPENDED";
    AccountStatus["CLOSED"] = "CLOSED";
    AccountStatus["WRITTEN_OFF"] = "WRITTEN_OFF";
    AccountStatus["HARDSHIP"] = "HARDSHIP";
    AccountStatus["PAYMENT_ARRANGEMENT"] = "PAYMENT_ARRANGEMENT";
})(AccountStatus || (AccountStatus = {}));

export { AccountStatus, ConsumerAddressType, IdentityCheckStatus, PreferredPaymentMethod };
